enum Locations {
  Menu = "menu",
  Book = "book",
}

export default Locations;
